import { render, staticRenderFns } from "./CommodityFuturesGrid.vue?vue&type=template&id=821bd344"
import script from "./CommodityFuturesGrid.vue?vue&type=script&lang=js"
export * from "./CommodityFuturesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports